import _ from 'lodash';
import dateFns from 'date-fns';
import { fiflboxApi } from '@/utils/api';

const state = {
  payments: []
};

const classification = {
  1: '신규',
  2: '재등록'
};

const getters = {
  getPayments: state => type => {
    if (type === 'card') {
      return state.payments.filter(payment => payment.card > 0);
    }

    if (type === 'cash') {
      return state.payments.filter(payment => payment.cash > 0);
    }

    if (type === 'remainder') {
      return state.payments.filter(payment => payment.remainder > 0);
    }

    return state.payments;
  },
  getMembershipSalesRanks(state, getters) {
    const parentMembershipsInKey = getters.getParentMembershipsInKeys;
    const groupedMemberships = _.groupBy(state.payments, 'membership');
    const membershipSales = Object.keys(groupedMemberships).map(
      membershipId => {
        return {
          id: membershipId,
          membershipName: parentMembershipsInKey[membershipId]
            ? parentMembershipsInKey[membershipId].name
            : '',
          numOfSales: groupedMemberships[membershipId].length
        };
      }
    );

    getters.getParentMemberships
      .filter(membership => !membership.is_removed)
      .forEach(membership => {
        if (!groupedMemberships[membership.id]) {
          membershipSales.push({
            id: membership.id,
            membershipName: membership.name,
            numOfSales: 0
          });
        }
      });

    return _.orderBy(
      membershipSales,
      ['numOfSales'],
      ['desc', 'membershipName']
    );
  },
  getMembershipSalesByClassification(state) {
    const groupedPayments = _.groupBy(state.payments, 'classification');

    const sales = {};

    return [1, 2].map(classification => {
      return _.sumBy(groupedPayments[classification], 'total');
    });
  }
};

const mutations = {
  setPayments(state, payments) {
    state.payments = payments;
  }
};

const actions = {
  async syncPayments({ commit, dispatch }, payload) {
    const { data: payments } = await fiflboxApi.v2.getMembershipPayments({
      paid_at_after: dateFns.format(
        dateFns.startOfMonth(payload.date),
        'YYYY-MM-DD'
      ),
      paid_at_before: dateFns.format(
        dateFns.endOfMonth(payload.date),
        'YYYY-MM-DD'
      )
    });

    if (dateFns.isBefore(payload.date, new Date('2019-01-01'))) {
      return commit('setPayments', []);
    }

    commit('setPayments', payments);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
